export default __webpack_public_path__ + "static/four-commercial-f0ee400ec2988e7e1624f1df03a25057.jpg";